/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Footer_CopyrightInputs */

const en_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. All rights reserved.`)
};

const es_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. Todos los derechos reservados.`)
};

const fr_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. Tous droits réservés.`)
};

const de_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. Alle Rechte vorbehalten.`)
};

const ja_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. All rights reserved.`)
};

const zh_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. 保留所有权利。`)
};

const ar_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. جميع الحقوق محفوظة.`)
};

const id_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. Hak Cipta Dilindungi Undang-Undang.`)
};

const it_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. Tutti i diritti riservati.`)
};

const ru_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. Все права защищены.`)
};

const pt_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. Todos os direitos reservados.`)
};

const ko_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Shoot Share Connect. All rights reserved.`)
};

/**
* | output |
* | --- |
* | "© {year} Shoot Share Connect. All rights reserved." |
*
* @param {Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_copyright = /** @type {((inputs: Footer_CopyrightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CopyrightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_copyright(inputs)
	if (locale === "es") return es_footer_copyright(inputs)
	if (locale === "fr") return fr_footer_copyright(inputs)
	if (locale === "de") return de_footer_copyright(inputs)
	if (locale === "ja") return ja_footer_copyright(inputs)
	if (locale === "zh") return zh_footer_copyright(inputs)
	if (locale === "ar") return ar_footer_copyright(inputs)
	if (locale === "id") return id_footer_copyright(inputs)
	if (locale === "it") return it_footer_copyright(inputs)
	if (locale === "ru") return ru_footer_copyright(inputs)
	if (locale === "pt") return pt_footer_copyright(inputs)
	return ko_footer_copyright(inputs)
});